import { createSelector } from 'reselect';
import { OrgProfileState, OrgProfileUpdateState } from './types';

const selectOrgProfileState = (state: { orgProfile: OrgProfileState }) => state.orgProfile;
const selectUpdateOrgProfileState = (state: { updateOrgProfile: OrgProfileUpdateState }) => state.updateOrgProfile;


export const selectOrgProfile = createSelector(
  selectOrgProfileState,
  (orgProfileState) => orgProfileState.profile
);

export const selectOrgProfileLoading = createSelector(
  selectOrgProfileState,
  (orgProfileState) => orgProfileState.loading
);

export const selectOrgProfileError = createSelector(
  selectOrgProfileState,
  (orgProfileState) => orgProfileState.error
);

export const selectUpdateOrgProfileLoading = createSelector(
  selectUpdateOrgProfileState,
  (updateOrgProfileState) => updateOrgProfileState.loading
);

export const selectUpdateOrgProfileError = createSelector(
  selectUpdateOrgProfileState,
  (updateOrgProfileState) => updateOrgProfileState.error
);

export const selectUpdateOrgProfileSuccess = createSelector(
  selectUpdateOrgProfileState,
  (updateOrgProfileState) => updateOrgProfileState.message
);